import React, { useCallback, useContext, useEffect, useState } from 'react';
import { __RouterContext } from 'react-router';
import { MplServiceClientFactory } from '../../../api/MplServiceClientFactory';
import { IMplServiceClient } from '../../../api/IMplServiceClient';
import { AppContext } from '../../../contexts/AppContext';
import { WorkflowEventTypes } from '@amzn/awscat-pattern-library-service-model';
import PostReadonlyViewer from './PostReadonlyViewer';
import PostEditingViewer from './PostEditingViewer';
import { Spinner } from '@amzn/awsui-components-core';
import { createWorkflowEventWithStatePolling } from '../../../api/CreateWorkflowEventWithStatePolling';
import { isAllowedToEditPost } from '../../../api/ContentUtil';
import { fetchImageInBase64Format } from '../../../editor/utils';

const mplService: IMplServiceClient = MplServiceClientFactory.create();

const PostViewer = () => {
  const routerContext = useContext(__RouterContext);
  const appContext = useContext(AppContext);
  const routerParams = routerContext.match?.params as any;
  const postId = decodeURIComponent(routerParams?.contentId);
  const entities = appContext.entities;

  const [post, setPost] = useState(null);
  const [publishedDate, setPublisedDate] = useState(null);
  const [workflow, setWorkflow] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditingEnabled, setIsEditingEnabled] = useState(false);

  const fetchPost = useCallback(async () => {
    setIsLoading(true);
    try {
      const userProfile = appContext.authnInfo?.userProfile;
      // @ts-expect-error TS2345 - strict migration
      if (isAllowedToEditPost(userProfile)) {
        const { workflow: contentWorkflow, content: draftPost } =
          await mplService.getContent(postId);
        const enabledEditing =
          contentWorkflow &&
          !!contentWorkflow.lock &&
          // @ts-expect-error TS18048 - strict migration
          contentWorkflow.lock.acquiredBy === userProfile.userId;
        // @ts-expect-error TS2345 - strict migration
        setPost(draftPost);
        // @ts-expect-error TS2345 - strict migration
        setWorkflow(contentWorkflow);
        setIsEditingEnabled(enabledEditing);
      } else {
        const { content, publicationDate } = await mplService.getPublication(postId);
        // @ts-expect-error TS2345 - strict migration
        setPost(content);
        // @ts-expect-error TS2345 - strict migration
        setPublisedDate(publicationDate);
      }
    } finally {
      setIsLoading(false);
    }
  }, [postId, appContext.authnInfo?.userProfile]);

  useEffect(() => {
    fetchPost();
  }, [postId, fetchPost]);

  const submitEditing = async () => {
    // @ts-expect-error TS2339 - strict migration
    const { draftWorkflowId } = workflow;
    await createWorkflowEventWithStatePolling(postId, draftWorkflowId, WorkflowEventTypes.LOCK, '');
    await fetchPost();
  };

  const fetchImage = async (srcUrl: string) => {
    return await fetchImageInBase64Format(srcUrl, mplService);
  };

  const showEditingControl = () =>
    // @ts-expect-error TS2339 - strict migration
    workflow && !workflow.lock && isAllowedToEditPost(appContext.authnInfo?.userProfile);

  if (isLoading) {
    return <Spinner />;
  }
  return isEditingEnabled ? (
    <PostEditingViewer
      postId={postId}
      // @ts-expect-error TS2322 - strict migration
      post={post}
      // @ts-expect-error TS18047 - strict migration
      audience={workflow.contentAudience}
      // @ts-expect-error TS2322 - strict migration
      workflow={workflow}
      header="Edit Post"
      onPostSaved={fetchPost}
      fetchImage={fetchImage}
    />
  ) : (
    <PostReadonlyViewer
      postId={postId}
      // @ts-expect-error TS2322 - strict migration
      post={post}
      // @ts-expect-error TS2322 - strict migration
      workflow={workflow}
      // @ts-expect-error TS2322 - strict migration
      showEditingControl={showEditingControl()}
      onEditSubmited={submitEditing}
      fetchImage={fetchImage}
    />
  );
};

export default PostViewer;
